import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';

@Injectable({
  providedIn: 'root',
})
export class CustomizationService {
  httpClient = inject(HttpClient);

  constructor() {}

  getCustomizations(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/restaurants/customizations').pipe(
      catchError((error) => {
        console.error('Error fetching customizations:', error);
        return of(error);
      }),
    );
  }

  getCustomizationById(customizationId: any): Observable<any> {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/restaurants/customizations/' + customizationId)
      .pipe(
        catchError((error) => {
          console.error('Error fetching customization by id:', error);
          return of(error);
        }),
      );
  }

  addCustomization(customization: any): Observable<any> {
    return this.httpClient
      .post<any>(ServiceConstant.apiUrl + '/restaurants/customizations', customization)
      .pipe(
        catchError((error) => {
          console.error('Error creating customization:', error);
          return of(error);
        }),
      );
  }

  editCustomization(customization: any, customizationId: any): Observable<any> {
    return this.httpClient
      .patch<any>(
        ServiceConstant.apiUrl + '/restaurants/customizations/' + customizationId,
        customization,
      )
      .pipe(
        catchError((error) => {
          console.error('Error editing customization:', error);
          return of(error);
        }),
      );
  }

  deleteCustomization(customizationId: any): Observable<any> {
    return this.httpClient
      .delete<any>(ServiceConstant.apiUrl + '/restaurants/customizations/' + customizationId)
      .pipe(
        catchError((error) => {
          console.error('Error deleting customization:', error);
          return of(error);
        }),
      );
  }
}
